export default function stats(data) {
  const { hasManyResults, hasOneResult, nbHits } = data;

  if (hasManyResults) {
    return `${nbHits} results`;
  } else if (hasOneResult) {
    return '1 result';
  } else {
    return '';
  }
}
